import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { AccountEditorComponent } from './account-editor.component';

export { AccountEditorModule } from './account-editor.module';
export const accountEditorModule = angular.module('accountEditorModule', [])
	.directive('ngxAccountEditor', downgradeComponent({ component: AccountEditorComponent }))
	.name;
